import { AccessLevelModel } from 'shared/domain/issue/mapping/accessLevel/model/types';
import { Identificable, LabelledEntity } from 'shared/types/commonView';
import type { WorkflowDecisionType } from 'shared/domain/workflow/types';
import { OperationV1 } from 'views/issue/issueHistory/types';

export enum DocumentUploadOperationType {
  documentUploadAttempt = 'documentUploadAttempt',
  documentUploadSuccess = 'documentUploadSuccess',
  documentUploadFailure = 'documentUploadFailure',
}

export enum DocumentDrawingOperationType {
  documentDrawingClear = 'documentDrawingClear',
  documentDrawingUploadAttempt = 'documentDrawingUploadAttempt',
  documentDrawingUploadSuccess = 'documentDrawingUploadSuccess',
  documentDrawingUploadFailure = 'documentDrawingUploadFailure',

  documentDrawingMergedSuccess = 'documentDrawingMergedSuccess',
  documentDrawingMergedFailure = 'documentDrawingMergedFailure',
  documentDrawingMergedPending = 'documentDrawingMergedPending',
  documentDrawingMergedUploadedUnavailable = 'documentDrawingMergedUploadedUnavailable',
}

export enum EventOperationType {
  eventCreation = 'eventCreation',
}

export enum UserAccessOperationType {
  userAccessCreation = 'userAccessCreation',
  userAccessModification = 'userAccessModification',
  userAccessDeletion = 'userAccessDeletion',
}

export enum DocumentDescriptionOperationType {
  documentDescriptionUpdate = 'documentDescriptionUpdate',
}

export enum DocumentExportToDocumentationOperationType {
  documentExportedToDocumentation = 'documentExportedToDocumentation',
}

export enum LinkedDocumentationOperationType {
  documentationImported = 'documentationImported',
  linkedDocumentationRemoved = 'linkedDocumentationRemoved',
}

export enum StageChangeOperationType {
  stageChange = 'stageChange',
  stageChangedAutomatically = 'stageChangedAutomatically',
}

export enum WorkflowDecisionOperationType {
  workflowDecisionMade = 'workflowDecisionMade',
}

export type IssueChangelogOperationType =
  | DocumentUploadOperationType
  | DocumentDrawingOperationType
  | EventOperationType
  | UserAccessOperationType
  | DocumentDescriptionOperationType
  | DocumentExportToDocumentationOperationType
  | LinkedDocumentationOperationType
  | StageChangeOperationType
  | WorkflowDecisionOperationType;

export enum IssueChangelogEntityType {
  issueDocument = 'issueDocument',
  issueDocumentDrawing = 'issueDocumentDrawing',
  eventDocument = 'eventDocument',
  eventDocumentDrawing = 'eventDocumentDrawing',
  event = 'event',
  userAccess = 'userAccess',
  linkedDocumentation = 'linkedDocumentation',
  stage = 'stage',
  workflowDecision = 'workflowDecision',
}

export const eventOperationEntityTypes = Object.values([
  IssueChangelogEntityType.event,
  IssueChangelogEntityType.eventDocument,
  IssueChangelogEntityType.eventDocumentDrawing,
]);

export const issueOperationEntityTypes = Object.values([
  IssueChangelogEntityType.issueDocument,
  IssueChangelogEntityType.linkedDocumentation,
  IssueChangelogEntityType.issueDocumentDrawing,
]);

export type OperationV2Dto = Identificable & {
  _id: string;
  createdBy: LabelledEntity | null;
  createdAt: string;
  entityType: IssueChangelogEntityType;
  operationType: IssueChangelogOperationType;
  // Final aggregated result for grouped upload operations sharing the same documentId
  finalOperationResult?: IssueChangelogOperationType;
  projectId: string;
  issueId: string;
  eventId: string | null;
  eventTitle: string | null;
  documentId: string | null;
  documentTitle: string | null;
  accessLevelAfter: AccessLevelModel | null;
  accessLevelBefore: AccessLevelModel | null;
  accessingUser: string | null;
  userAccessId: string | null;
  descriptionBefore: string | null;
  descriptionAfter: string | null;
  documentationId: string | null;
  documentationName: string | null;
  versionId: string | null;
  stageIdBefore: string | null;
  stageIdAfter: string | null;
  workflowDecisionType: WorkflowDecisionType | null;
  workflowDecisionStageId: string | null;
  version: 2;
};
export interface ChangelogOutDto {
  patchesV1: OperationV1[];
  patchesV2: OperationV2Dto[];
}
